import { useOnboardingStatus as useOnboardingStatusQuery, useCompleteStepMutation, useVisitStepMutation } from '../queries/onboarding';
import type { OnboardingStepKey } from './onboardingSteps';

export const useOnboardingStatus = () => {
  const { data: status = null, isLoading: loading, error } = useOnboardingStatusQuery();
  const completeStepMutation = useCompleteStepMutation();
  const visitStepMutation = useVisitStepMutation();

  const errorMessage = error
    ? ((error as { response?: { data?: { error?: string } } }).response?.data?.error ??
      'Failed to load onboarding status')
    : null;

  const completeStep = async (stepKey: string) => {
    const { data } = await completeStepMutation.mutateAsync(stepKey);
    return data;
  };

  const visitStep = async (stepKey: OnboardingStepKey) => {
    return visitStepMutation.mutateAsync(stepKey);
  };

  return { status, loading, error: errorMessage, completeStep, visitStep };
};
